<template>
  <div>
    <v-select
      :value="value"
      :options="countries"
      :disabled="readonly"
      :reduce="country => country.id"
      label="name"
      :dir="dir?dir:(isRTL ? 'rtl' : 'ltr')"
      :loading="loading"
      :multiple="multiple"
      :clearable="clearable"
      :class="{'select-size-lg': size === 'lg', 'select-size-sm': size === 'sm', 'is-invalid': state === false}"
      :placeholder="placeholder"
      autocomplete="off"
      @input="$emit('input', $event)"
    >
      <template
        slot="option"
        slot-scope="option"
      >
        <div class="d-center">
          <span
            class="flag ff-sm"
            :class="`flag-${option.id ? option.id.toUpperCase() : ''}`"
          />
          {{ option.name }}
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option"
      >
        <div class="selected d-center">
          {{ option.name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import countriesTimezones from 'countries-and-timezones'
import CountriesAPI from '@/API/helpers/countries-api'

export default {
  name: 'CountrySelect',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Array],
      default: 'KW',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    dir: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: true,
    },
    allowedCountries: {
      type: Array,
      default: () => [],
    },
    autoFetchCountry: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countries: [],
      loading: false,
    }
  },
  watch: {
    autoFetchCountry(fetch) {
      if (fetch) {
        this.fetchCurrentCountry()
      }
    },
  },
  mounted() {
    this.fetchCountries()
    if (this.autoFetchCountry) {
      this.fetchCurrentCountry()
    }
  },
  methods: {
    fetchCountries() {
      this.countries = Object.values(countriesTimezones.getAllCountries())
      if (this.allowedCountries.length > 0) {
        this.countries = this.countries.filter(c => this.allowedCountries.includes(c.id))
      }
    },
    fetchCurrentCountry() {
      CountriesAPI.getCurrentCountry().then(c => {
        if (!this.value && (this.allowedCountries.length === 0 || this.allowedCountries.includes(c.alpha2Code))) {
          this.$emit('input', c.alpha2Code)
        }
      })
    },
    getCountryTimezones(id) {
      return countriesTimezones.getTimezonesForCountry(id).map(timezone => timezone.name)
    },
    getCountryName(id) {
      return countriesTimezones.getCountry(id)?.name || id
    },
    deselectAll() {
      this.$emit('input', '')
    },
  },
}
</script>
